import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId, TEntityVersion } from '~/types/models'
import type { IAccount, IAccountOverview } from '~/types/account/models'

const apiEntityPath = '/api/accounts'

export async function getAccounts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getAccounts.name
  return httpGet<IAccount[]>({ callingMn, apiPath })
}

export async function createAccount(entity: IAccount) {
  const callingMn = createAccount.name
  const apiPath = apiEntityPath
  return httpPost<IAccount>({ callingMn, apiPath, entity })
}

export async function getAccountOverview(id: string) {
  const callingMn = getAccountOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<IAccountOverview>({
    callingMn,
    apiPath,
  })
}

export async function updateAccount(
  entityData: Partial<IAccount>,
  id: TEntityId
) {
  const callingMn = updateAccount.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIAccount = Partial<IAccount>
  return httpPatchMerge<TPartialIAccount>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteAccount(entityData: IAccount) {
  const callingMn = deleteAccount.name
  const apiPath = apiEntityPath
  return httpDelete<IAccount>({
    callingMn,
    apiPath,
    entityData,
  })
}
